import { render, staticRenderFns } from "./img-gif.vue?vue&type=template&id=b8e6c3d6"
import script from "./img-gif.vue?vue&type=script&lang=js"
export * from "./img-gif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports